import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Dashboard.css';

const orgPaths = [
  '/admin/micro-organizations',
  '/admin/mid-organizations',
  '/admin/large-organizations',
  '/admin/enterprise-organizations',
];

function closeSidenav() {
  document.querySelector('.admin-sidenav')?.classList.remove('open');
  document.querySelector('.sidenav-backdrop')?.classList.remove('visible');
  document.body.style.overflow = '';
}

export default function AdminSideNav() {
  const location = useLocation();
  const [orgOpen, setOrgOpen] = useState(orgPaths.includes(location.pathname));

  useEffect(() => {
    setOrgOpen(orgPaths.includes(location.pathname));
    closeSidenav(); // close the mobile / tablet menu after every page change
  }, [location.pathname]);

  // Escape key closes the menu
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') closeSidenav(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, []);

const userName     = localStorage.getItem('userName') || 'Admin';
const avatarLetter = userName.charAt(0).toUpperCase();
const isActive     = (path) => location.pathname === path;
const setInternal  = () => localStorage.setItem('internalNav', 'true');

  return (
    <aside className="admin-sidenav">
      {/* close (X) button - visible on mobile / tablet only (CSS) */}
      <button
        type="button"
        className="sidenav-close-btn"
        aria-label="Close navigation menu"
        onClick={closeSidenav}
      >
        <svg viewBox="0 0 24 24"><path d="M6 6l12 12M18 6L6 18" /></svg>
      </button>

      <div className="sidenav-logo">
        <img
  src="/assets/lo.png"
  alt="Outstanding Workplaces"
  className="sidenav-logo-image"
/>
      </div>

      <nav className="sidenav-menu">

        <Link
          to="/admin/dashboard"
          className={`sidenav-item${isActive('/admin/dashboard') ? ' active' : ''}`}
          onClick={() => { setOrgOpen(false); setInternal(); }}
        >
          <img src="/dashboard-line.png" alt="Dashboard" className="sidenav-icon-img" />
          Dashboard
        </Link>

        <div
          className={`sidenav-item org-parent${orgPaths.includes(location.pathname) ? ' active' : ''}`}
          onClick={() => setOrgOpen(prev => !prev)}
        >
          <img src="/codicon_organization.png" alt="Organizations" className="sidenav-icon-img" />
          Organizations
          <span className={`sidenav-arrow${orgOpen ? ' open' : ''}`}>▼</span>
        </div>

        {orgOpen && (
          <div className="sidenav-submenu">
            <Link to="/admin/micro-organizations" onClick={setInternal}
              className={`sidenav-subitem${isActive('/admin/micro-organizations') ? ' active' : ''}`}>
              • Micro-Organization
            </Link>
            <Link to="/admin/mid-organizations" onClick={setInternal}
              className={`sidenav-subitem${isActive('/admin/mid-organizations') ? ' active' : ''}`}>
              • Mid-Scale Organization
            </Link>
            <Link to="/admin/large-organizations" onClick={setInternal}
              className={`sidenav-subitem${isActive('/admin/large-organizations') ? ' active' : ''}`}>
              • Large Organization
            </Link>
            <Link to="/admin/enterprise-organizations" onClick={setInternal}
              className={`sidenav-subitem${isActive('/admin/enterprise-organizations') ? ' active' : ''}`}>
              • Enterprise Organization
            </Link>
          </div>
        )}

        <Link
          to="/admin/nominations"
          className={`sidenav-item${isActive('/admin/nominations') ? ' active' : ''}`}
          onClick={() => { setOrgOpen(false); setInternal(); }}
        >
          <img src="/solar_medal-ribbons-star.png" alt="Nomination" className="sidenav-icon-img" />
          Nomination
        </Link>

        {/* ✅ NEW: Onboarding Details */}
        <Link
          to="/admin/onboardingdata"
          className={`sidenav-item${isActive('/admin/onboardingdata') ? ' active' : ''}`}
          onClick={() => { setOrgOpen(false); setInternal(); }}
        >
          <img src="/Onboardingdetails-icon.png" alt="Onboarding Details" className="sidenav-icon-img" />
          Onboarding Details
        </Link>

        <Link
          to="/admin/insights"
          className={`sidenav-item${isActive('/admin/insights') ? ' active' : ''}`}
          onClick={() => { setOrgOpen(false); setInternal(); }}
        >
          <img src="/mynaui_notification.png" alt="Subscribers" className="sidenav-icon-img" />
          Subscribers
        </Link>

        <Link
          to="/admin/gallery"
          className={`sidenav-item${isActive('/admin/gallery') ? ' active' : ''}`}
          onClick={() => { setOrgOpen(false); setInternal(); }}
        >
          <img src="/solar_gallery-add.png" alt="Gallery" className="sidenav-icon-img" />
          Gallery
        </Link>

      </nav>

      <div className="sidenav-user">
        <div className="sidenav-user-avatar">{avatarLetter}</div>
        <div className="sidenav-user-name">{userName}</div>
      </div>
    </aside>
  );
}